/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ApgarScore from './apgar-score';
import ApgarScoreDetail from './apgar-score-detail';
import ApgarScoreUpdate from './apgar-score-update';
import ApgarScoreDeleteDialog from './apgar-score-delete-dialog';

const ApgarScoreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ApgarScore />} />
    <Route path="new" element={<ApgarScoreUpdate />} />
    <Route path=":id">
      <Route index element={<ApgarScoreDetail />} />
      <Route path="edit" element={<ApgarScoreUpdate />} />
      <Route path="delete" element={<ApgarScoreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ApgarScoreRoutes;
